import { useEffect, useRef } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import type { Schema } from '@fhs/client';
import { Button, IconLocked, tokens } from '@fhs/ui';

import { useCartValues } from '../state/cart-store';
import { usePaymentProcessor } from '../state/processor';

type CartState = Schema['CartState']['type'];

export function CheckoutScreen() {
  const { cartEntries } = useCartValues();
  const showEmptyState = cartEntries.length === 0;

  return (
    <>
      <AutoPriceCall_ state={undefined} />
      {false && <View style={styles.uiblock} />}

      {!showEmptyState && (
        <SafeAreaView>
          <View style={[styles.container, styles.buttonContainer]}>
            <ActionButton state={undefined} />
          </View>
        </SafeAreaView>
      )}
    </>
  );
}

function ActionButton({ state }: { state: undefined | CartState }) {
  const { isPending, makePaymentAndCommit } = usePaymentProcessor();

  switch (state) {
    case 'LOYALTY_INVALID':
      // todo, show loyalty error states
      return (
        <Button size="lg" disabled>
          <Button.Icon>
            <IconLocked />
          </Button.Icon>
          <Button.Text>Place Secure Order</Button.Text>
        </Button>
      );

    case 'NEEDS_LOYALTY_VALIDATION':
      return (
        <Button size="lg" loading>
          <Button.Text>Validating Offers</Button.Text>
        </Button>
      );

    default:
      return (
        <Button
          size="lg"
          loading={isPending || state === 'PRICE_REQUESTED'}
          onPress={() => {
            makePaymentAndCommit();
          }}
        >
          <Button.Icon>
            <IconLocked />
          </Button.Icon>
          <Button.Text>Place Secure Order</Button.Text>
        </Button>
      );
  }
}

const styles = StyleSheet.create({
  buttonContainer: {
    borderTopColor: tokens.colors.$black10,
    borderTopWidth: StyleSheet.hairlineWidth,
  },
  container: {
    marginHorizontal: 'auto',
    padding: 16,
    width: '100%',
  },
  flex1: {
    flex: 1,
  },
  list: {
    gap: 16,
  },
  subtotalContainer: {
    backgroundColor: tokens.colors.$houseLight,
    width: '100%',
    height: 48,
  },
  subtotalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  uiblock: {
    backgroundColor: tokens.colors.$black10,
    zIndex: 1000,
    opacity: 0.5,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
});

function AutoPriceCall_({ state }: { state: undefined }) {
  const hasRanAutoMutate = useRef(false);

  useEffect(() => {
    // This is only allowed to run once.
    // if the checkout page handles a price call it should not happen again.
    if (hasRanAutoMutate.current === true) {
      return;
    }

    if (false) {
      // eslint-disable-next-line
      console.log('check');
      hasRanAutoMutate.current = true;
    }
  }, [state]);

  return null;
}
